import React from 'react';

import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router';

import StatusLabels from '@src/components/common/Display/titles/StatusLabels';
import { Carousel } from '@src/components/ui';
import { imageOrDefault } from '@src/utils/defaultImage';
import { getImageSource } from '@src/utils/getImage';
import { resourceURL } from '@src/utils/urlHelpers';

import styles from './featured.scss';

const FeaturedContent = ({ articles, urlPrefix }) => {
    const renderLeft = (article) => {
        const image = imageOrDefault(article.image);
        const imgSource = getImageSource(image, 1200);

        return (
            <Col lg={4} className="left-content p-0">
                {
                    imgSource && (
                        <div
                            className="featured-image"
                            style={{ backgroundImage: `url(${imgSource})` }}
                        />
                    )
                }
            </Col>
        );
    };

    const renderRight = (article) => {
        return (
            <Col lg={8} className="right-content">
                <Card className="border-0 rounded-0">
                    <Card.Body className="border-0 rounded-0">
                        <Card.Header className="border-0 rounded-0 pt-1 ps-0 pe-0">
                            <h2>
                                <StatusLabels
                                    expiredAt={article.expired_at}
                                    status={article.status}
                                    publishedAt={article.published_at}
                                />
                                {article.title}
                            </h2>
                        </Card.Header>
                        <Card.Text>{article.description}</Card.Text>
                    </Card.Body>
                    <Card.Footer className="border-0 rounded-0 pb-3">
                        <Link
                            to={resourceURL(urlPrefix, article.slug)}
                            className="btn btn-primary"
                        >
                            Read
                        </Link>
                    </Card.Footer>
                </Card>
            </Col>
        );
    };

    const renderArticle = (article) => {
        return (
            <Row key={article.id} title={`article ${article.title}`}>
                <Col>
                    <Row className="m-0">
                        {renderLeft(article)}
                        {renderRight(article)}
                    </Row>
                </Col>
            </Row>
        );
    };

    return (
        <Row className={`mb-5 ${styles['featured-content']}`}>
            <Col>
                <Carousel
                    fade
                >
                    {articles.map((a) => renderArticle(a))}
                </Carousel>
            </Col>
        </Row>
    );
};

FeaturedContent.propTypes = {
    articles: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        expired_at: PropTypes.string,
        slug: PropTypes.string.isRequired,
        title: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.shape({
            alt: PropTypes.string,
            source: PropTypes.string,
        }),
    })),
    urlPrefix: PropTypes.string.isRequired,
};

export default React.memo(FeaturedContent);
